import { useMemo, useEffect, useState } from "react";
import * as React from 'react';
import { styled } from '@mui/material/styles';
// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// react-table components
// import { useTable, usePagination, useGlobalFilter, useAsyncDebounce, useSortBy } from "react-table";

// @mui material components


//   React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";

import { Box, Card, Checkbox, Container, Divider, FormControl, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import MDButton from "components/MDButton";
import { CloudUpload, FormatAlignJustify } from "@mui/icons-material";

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

function UploadDocument() {

    return (
        <Container>
            <MDBox px={2}>
                    <MDBox pt={4} pb={3} px={3}>

                        <MDBox component="form" role="form">
                            <MDBox pt={4} pb={3} px={3}>
                                <MDBox component="form" role="form">
                                    <MDBox mb={4} mr={3} >
                                        <InputLabel sx={{ fontWeight: 'bold' }} id="BankDetails" mb={2}>Document Upload</InputLabel>
                                        <MDBox  sx={{ display: 'grid', gridTemplateColumns: 'repeat(12, 1fr)', gap: 2 }}>
                                            <MDButton
                                                sx={{ gridColumn: 'span 12',justifyContent:'space-between' }}
                                                component="label"
                                                role={undefined}
                                                variant="contained"
                                                tabIndex={-1}
                                                startIcon={<CloudUpload />}
                                            >
                                                Adharcard
                                                <MDInput
                                                sx={{ gridColumn: 'span 4'}}
                                                    type="file"
                                                    onChange={(event) => console.log(event.target.files)}
                                                    multiple
                                                />
                                            </MDButton>
                                        </MDBox>
                                        <MDBox sx={{ display: 'grid', gridTemplateColumns: 'repeat(12, 1fr)', gap: 2 }}>
                                            <MDButton
                                                sx={{ gridColumn: 'span 12',justifyContent:'space-between' }}
                                                component="label"
                                                role={undefined}
                                                variant="contained"
                                                tabIndex={-1}
                                                startIcon={<CloudUpload />}
                                            >
                                                Pancard
                                                <MDInput
                                                sx={{ gridColumn: 'span 4'}}
                                                    type="file"
                                                    onChange={(event) => console.log(event.target.files)}
                                                    multiple
                                                />
                                            </MDButton>
                                        </MDBox>
                                        <MDBox sx={{ display: 'grid', gridTemplateColumns: 'repeat(12, 1fr)', gap: 2 }}>
                                        <MDButton
                                        sx={{ gridColumn: 'span 12',justifyContent:'space-between' }}
                                            component="label"
                                            role={undefined}
                                            variant="contained"
                                            tabIndex={-1}
                                            startIcon={<CloudUpload />}
                                        >
                                            Certificate and marlsheets of Tenth,Plus 2
                                            <MDInput
                                             sx={{ gridColumn: 'span 4'}}
                                                type="file"
                                                onChange={(event) => console.log(event.target.files)}
                                                multiple
                                            />
                                        </MDButton>
                                        </MDBox>
                                        <MDBox sx={{ display: 'grid', gridTemplateColumns: 'repeat(12, 1fr)', gap: 2 }}>
                                        <MDButton
                                            sx={{ gridColumn: 'span 12',justifyContent:'space-between' }}
                                            component="label"
                                            role={undefined}
                                            variant="contained"
                                            tabIndex={-1}
                                            startIcon={<CloudUpload />}
                                        >
                                            Certificate of degree / post graduation
                                            <MDInput
                                             sx={{ gridColumn: 'span 4'}}
                                                type="file"
                                                onChange={(event) => console.log(event.target.files)}
                                                multiple
                                            />
                                        </MDButton>
                                        </MDBox>
                                    </MDBox>

                                    <MDBox mt={4} mb={1} sx={{ display: 'grid', gridAutoColumns: '1fr', gap: 1 }}>
                                        <MDBox sx={{ gridRow: '1', gridColumn: '4 / 5' }}>
                                            <MDButton variant="gradient" color="info" sx={{ width: '30ch' }}>
                                                Save
                                            </MDButton>
                                        </MDBox>
                                    </MDBox>
                                </MDBox>
                            </MDBox>
                        </MDBox>
                    </MDBox>
            </MDBox>
        </Container>
    );
}
export default UploadDocument;
